import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LockService {
  get locked(): boolean {
    return !!localStorage.getItem('locked');
  }

  set locked(locked: boolean) {
    if (locked) {
      localStorage.setItem('locked', 'true');
    } else {
      localStorage.removeItem('locked');
    }
  }

  get pin(): string | null {
    return localStorage.getItem('pin');
  }

  set pin(pin: string | null) {
    if (pin === null) {
      localStorage.removeItem('pin');
    } else {
      localStorage.setItem('pin', pin);
    }
  }
}
